export default (hostname: string) =>
  process.env.RAZZLE_MINISITE_DOMAIN || hostname;
